import type { AllEntities, Permission } from 'c-sdk';

export type PermissionsDiff = { added: number[]; removed: number[] };

export type PermissionByCategory = {
    general: Permission[];
    admin: AdminPermissionGroups;
    namespaces: PermissionsByNamespace;
    rawPermissionsByNamespace: Record<PermissionNamespace, Permission[]>;
};

/**
 * The `admin` namespace isn't CRUD shaped, so it gets its own grouping: keyed on the segment after
 * `admin.` (campaign, page, data_status, ...), with anything that has no such segment - `admin`
 * itself, `admin.can_impersonate_user` - collected under {@link AdminGeneralGroup}.
 *
 * <Group name, Permissions>
 */
export type AdminPermissionGroups = Record<string, Permission[]>;

/**
 * <PermissionNamespace, PermissionsByEntity>
 */
export type PermissionsByNamespace = Record<PermissionNamespace, PermissionsByEntity>;

/**
 * <Entity Name,  EntityPermissions>
 */
export type PermissionsByEntity = Partial<Record<keyof AllEntities, EntityPermissions>>;

export type EntityPermissions = {
    create?: Permission;
    read?: Permission;
    update?: Permission;
    delete?: Permission;
};

export enum PermissionNamespace {
    Displays = 'displays',
    Pop = 'popdisplays',
    Portal = 'uniledportal',
    Reporting = 'reporting',
    Scoping = 'scoping',
}
